'use server';

import { SessionService } from '@/contexts/authentication';
import { readOwnedStory } from '@/contexts/stories/services/readOwnedStory';
import type { Story } from '@/contexts/stories/types/story';

/**
 * `null` = not found OR not yours (one answer, no existence leak) — the UI shows
 * the "story unavailable" screen. A throw = a real failure — the UI offers retry.
 */
export async function getStory(storyId: string): Promise<Story | null> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return null;
  return readOwnedStory(storyId, familyId);
}
